<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="modal-title-big">
            Уникальный идентификатор (UUID):
        </div>
        <div class="modal-borderline no-margin-top"></div>
        <div class="modal-uuid-grid ap-modal-element">
            <div id="data-uuid">{{uuid}}</div>
<!--            <div class="button-change ap-copy-uuid" v-on:click="copyUUID()">Скопировать</div>-->
        </div>
        <br/>
    </div>
</template>

<script>
    import SVGModalClose from "../../SVG/SVGModalClose";
    export default {
        name: "ModalUUID",
        components: {SVGModalClose},
        props: {
            uuid: {
                type: String,
            }
        }
    }
</script>

<style scoped>
    .modal-uuid-grid {
        display: grid;
        grid-template-columns: max-content auto;
        grid-column-gap: 10px;
    }

    .ap-copy-uuid {
        width: auto;
        text-align: center;
    }

</style>
